import { type BadgeType } from '@/types/badges';
import type { BadgeFactoryClientProps } from './badge-factory.client';
import BadgeFactoryClient from './badge-factory.client';
import { NumberedBadge } from './layouts/numbered/numbered-badge';
import { TextBadge } from './layouts/text/text-badge';

const BADGES = {
    jackpot: 'jackpot',
    new: 'new',
    exclusive: 'exclusive',
    trending: 'trending',
    'early-access': 'early-access',
    'hot-right-now': 'hot-right-now'
} as const;

type BadgeProps = Omit<BadgeFactoryClientProps, 'children'> & {
    badgeType: BadgeType;
    value?: number;
    forceTextBadge?: boolean;
    playerCount?: number;
};

const BadgeFactory = ({
    badgeType,
    feedsCode,
    value,
    isSWJTickerDisplayed = false,
    forceTextBadge = false,
    playerCount
}: BadgeProps) => {
    // Fail fast if there's nothing to render
    if (!badgeType || !(badgeType.toLowerCase() in BADGES)) {
        return null;
    }

    let badge = null;

    switch (badgeType) {
        case 'trending':
            if (value) {
                badge = <NumberedBadge numberToShow={value} />;
                break;
            }
        case 'jackpot':
        case 'exclusive':
        case 'new':
        case 'early-access':
        case 'hot-right-now':
            forceTextBadge = true;
        default:
            badge = <TextBadge label={badgeType} playerCount={playerCount} />;
            break;
    }

    return (
        <BadgeFactoryClient
            feedsCode={feedsCode}
            isSWJTickerDisplayed={isSWJTickerDisplayed}
            forceTextBadge={forceTextBadge}>
            {badge}
        </BadgeFactoryClient>
    );
};

export default BadgeFactory;
